module.exports = __webpack_public_path__ + "static/client2-572656546c87f979619d69dcb63bc51b.png";